<template>
  <div class="wy-alert-panel auto-qa trending-topic">
    <div v-if="controller.alertList.length>0">
      <div class="wy-alert-panel-item" :class="{'active': alertItem.isNew}" v-for="(alertItem, index) in controller.alertList" :key="index" @mouseover="controller.alertsPanelMouseOver">
        <span v-if="alertItem.isNew" class="blue-dot"></span>
        <div class="div-item div-header-title">
          <span v-if="controller.getPageName(alertItem)!=='Smart Tags'" class="product">{{controller.getPageName(alertItem)}}</span>
          <span v-if="controller.getPageName(alertItem)!=='Smart Tags'" class="dot">&nbsp;</span>
          <span class="date">{{controller.getDate(alertItem.actionDate)}}</span>
          <span class="dot">&nbsp;</span>
          <span class="date">{{controller.getTime(alertItem.actionDate)}}</span>
        </div>
        <div v-if="alertItem.metric=='monthlyUsage'" class="div-item div-title">{{controller.getMetricName(alertItem)}}</div>
        <div v-if="alertItem.metric=='nearOverage'" class="div-item div-title orange-alert-icon">{{controller.getMetricName(alertItem)}}</div>
        <div v-if="alertItem.metric=='overage'" class="div-item div-title red-alert-icon">{{controller.getMetricName(alertItem)}}</div>
        <div v-if="alertItem.metric=='monthlyNoUsage'" class="div-item div-title">{{controller.getMetricName(alertItem)}}</div>
        <div class="div-item" v-for="(alert, index) in alertItem.alerts"  :key="index">
          <div v-if="alertItem.metric=='monthlyUsage'" class="content">You have processed {{ alert.processedNumber }} interactions which is {{alert.usagePercentage}}% of your monthly limit.</div>
          <div v-if="alertItem.metric=='nearOverage'" class="content">
            <div>You have processed {{ alert.processedNumber }} interactions which is {{alert.usagePercentage}}% of your monthly limit. Going beyond your plan limit will likely incur an overage charge. </div>
            <br />
            <div>Please contact Calabrio Support at <a href="https://www.calabrio.com/support-request" target="_blank" class="a-link">calabrio.com</a> or message us at <span class="a-mailto">calabriosupport@calabrio.com</span> to manage your usage and overage fees.</div>
          </div>
          <div v-if="alertItem.metric=='overage'" class="content">
            <div>You have processed {{ alert.processedNumber }} interactions which is {{alert.usagePercentage}}% of your monthly limit. You are currently being charged an overage fee, and will continue to do so if more interactions are processed.</div>
            <br />
            <div>Please contact Calabrio Support at <a href="https://www.calabrio.com/support-request" target="_blank" class="a-link">calabrio.com</a> or message us at <span class="a-mailto">calabriosupport@calabrio.com</span> to manage your usage and overage fees.</div>
          </div>
          <div v-if="alertItem.metric=='monthlyNoUsage'" class="content">0 interactions were processed this month.</div>
          <div class="time-section">
            <span class="time-title">Billing cycle</span>
            <span class="time-value">{{controller.getDisplayDateWithoutYear(alert.monthlyBillingStartDate)}} to {{controller.getDisplayDateWithoutYear(alert.monthlyBillingEndDate)}}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div v-if="controller.processAlertStatus==1" class="no-data-content">
        No alerts for the current time period.
      </div>
      <div v-else-if="controller.processAlertStatus==2 && (controller.isC1Interactions && controller.isRoleAllow(4605) || controller.isC1AutoQA && controller.isRoleAllow(4705) || controller.isC1AutoQA && controller.isRoleAllow(4904) || controller.isC1SmartTags && controller.isRoleAllow(4900))" class="no-data-content">
        No alerts configured. Please setup alert rules to receive notifications and stay updated on data changes for metrics that matter to you.
      </div>
      <div v-else-if="controller.processAlertStatus==2" class="no-data-content">
        No alerts configured. Please contact your admin for assistance.
      </div>
      <div v-if="controller.processAlertStatus==2 && (controller.isC1Interactions && controller.isRoleAllow(4605) || controller.isC1AutoQA && controller.isRoleAllow(4705) || controller.isC1AutoQA && controller.isRoleAllow(4904) || controller.isC1SmartTags && controller.isRoleAllow(4900))" class="config-link" @click="controller.handleGoToConfigration">
        Go to Alerts Configuration
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'wy-autoQA-trending-topic-alert-template',
  props: ['controller']
})
</script>


<style lang="scss">
.wy-alert-panel.auto-qa.trending-topic {
  min-height: 300px;
  .el-loading-spinner .path {
    stroke: #000 !important;
  }
  .div-header-title .dot {
    top: 1px !important;
  }
  .div-title {
    padding: 18px 0px 8px 25px !important;
  }
  .div-item.div-title.orange-alert-icon {
    background-image: var(--site-notification-icon-alert-notification);
    height: 21.526px;
    background-repeat: no-repeat;
    padding: 18px 0px 10px 48px !important;
    background-position-y: 20px;
    background-position-x: 23px;
  }
  .div-item.div-title.red-alert-icon {
    background-image: var(--site-notification-icon-warning-notification);
    height: 21.526px;
    background-repeat: no-repeat;
    padding: 18px 0px 10px 48px !important;
    background-position-y: 20px;
    background-position-x: 23px;
  }
  .div-item {
    .content {
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 1.4;
      // height: 68px;
      .a-link {
        color: #006FE7;
        cursor: pointer;
      }
      .a-link:hover{
        background-color: #cee6ff;
      }
      // .a-link:visited {
      //   color: pink;
      // }
      .a-mailto {
        font-style: italic;
      }
    }
    .time-section {
      padding: 20px 0px 0px 0px;
      .time-title {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        padding-right: 10px;
        color: #6A767C;
      }
      .time-value {
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }
    }
  }
  .wy-alert-panel-item.active:hover {
    background-color: #ECEEF0 !important;
  }
}
</style>
